import { TextField } from '@mui/material'
import clsx from 'clsx'
import React, { forwardRef } from 'react'

import { UInputProps } from './type'

export const UInput = forwardRef<HTMLInputElement, UInputProps>(
  (props, ref) => {
    return (
      <TextField
        ref={ref}
        {...props}
        className={clsx('width-320', props.inputProps?.className)}
      />
    )
  }
)

UInput.displayName = 'UInput'
